import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './reducers';
import { authMiddleware, loggerMiddleware } from './middleware';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      authMiddleware,
      loggerMiddleware,
    ]),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;